import { render, staticRenderFns } from "./LKPublicationsFormdataOcrResultsTable.vue?vue&type=template&id=023f7af2&scoped=true&"
import script from "./LKPublicationsFormdataOcrResultsTable.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataOcrResultsTable.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsFormdataOcrResultsTable.vue?vue&type=style&index=0&id=023f7af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f7af2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VCheckbox,VChip,VDataTable,VEditDialog,VIcon,VListItem,VListItemAction,VListItemContent,VSelect,VSimpleCheckbox,VTextField,VTooltip})
